/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { SVGIcon, theme, Tooltip } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { IconWrap } from "~/components/Navbar/UserDropdown";
import { DetailsTitle } from "~/components/Styled/Common";

type TooltipTitleProps = {
  title: string;
  caption: string;
  minWidth?: string;
};
type StyledFlexContainerProps = {
  minWidth?: string;
};

const StyledDetailsTitle = styled(DetailsTitle)`
  min-width: 0;
  margin-right: ${theme.spacing.spacing01};
`;

const StyledFlexContainer = styled(FlexContainer)<StyledFlexContainerProps>`
  min-width: ${({ minWidth }) => (minWidth ? minWidth : "12rem")};
`;

function TooltipTitle({ title, caption, minWidth }: TooltipTitleProps) {
  return (
    <Tooltip position="left" caption={caption} status="notification">
      <StyledFlexContainer minWidth={minWidth}>
        <StyledDetailsTitle>{title}</StyledDetailsTitle>
        <IconWrap>
          <SVGIcon size="sm" name="info" />
        </IconWrap>
      </StyledFlexContainer>
    </Tooltip>
  );
}

export { TooltipTitle };
